import { Box, Flex, Heading, Paragraph } from "@eworkit/iris";
import React from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { AnimatedProgressBar } from "@/components/Progress";

type DashboardProfileCompleteness = {
  points?: number;
  maximum: number;
};

export const DashboardProfileCompleteness: FC<DashboardProfileCompleteness> = ({ points, maximum }) => {
  const { t } = useTranslation("session");
  const progress = points ? (points / maximum) * 100 : 0;

  return (
    <Box pl="xs" pb={["0", null, null, "xs"]} borderRadius="md">
      <Flex alignItems="center">
        <Box pr="md">
          <Flex>
            {points !== undefined && (
              <Paragraph size="p-md">
                <Heading as={Paragraph} size="h-xs" bold>
                  {points}
                </Heading>{" "}
                {t("CONSULTANT_PROFILES.COMPLETENESS.POINTS")}
              </Paragraph>
            )}
          </Flex>
        </Box>
        <Box flexGrow={2}>
          <AnimatedProgressBar progress={progress} />
        </Box>
      </Flex>
    </Box>
  );
};
